import img_logo_tp from '../images/icon_b_logo.png';

export function showRouterFallback() {
  return (
    <div className='app view_center ntv_bga_color_b' style={{flexDirection : 'column'}}>
      <img
        alt='logo'
        src={img_logo_tp}
        style={{
          maxWidth: '60vw',
          maxHeight: '30vh',
          width: 'auto',
          height: 'auto',
          objectFit: 'contain',
          margin: '0 auto',
          display: 'block'
        }}
      />
    </div>
  );
}
